import formatsIndex from './index'
import keirekishoFormatsIndex from './keirekisho_index'
import rirekishoFormatsIndex from './rirekisho_index'
import yagiofferFormatsIndex from './yagioffer_index'
import etcFormatsIndex from './etc_index'
export default (id) => {
  let formatDetail = formatsIndex.find(function (format) {
    return format.id === id
  })
  let keirekishoFormatsDetail = keirekishoFormatsIndex.find(function (format) {
    return format.id === id
  })
  let rirekishoFormatsDetail = rirekishoFormatsIndex.find(function (format) {
    return format.id === id
  })
  let yagiofferFormatsDetail = yagiofferFormatsIndex.find(function (format) {
    return format.id === id
  })
  let etcFormatsDetail = etcFormatsIndex.find(function (format) {
    return format.id === id
  })
  if (formatDetail) {
    return formatDetail
  } else if (keirekishoFormatsDetail) {
    return keirekishoFormatsDetail
  } else if (rirekishoFormatsDetail) {
    return rirekishoFormatsDetail
  } else if (yagiofferFormatsDetail) {
    return yagiofferFormatsDetail
  } else if (etcFormatsDetail) {
    return etcFormatsDetail
  }
  return formatDetail

  if (!formatDetail) {
    return keirekishoFormatsIndex.find(function (format) {
      return format.id === id
    })
  } else {
    if (!formatDetail) {
      return yagiofferFormatsIndex.find(function (format) {
        return format.id === id
      })
    } else {
      if (!formatDetail) {
        return yagiofferFormatsIndex.find(function (format) {
          return format.id === id
        })
      } else {
        return formatDetail
      }
    }
  }

}
